import { render, staticRenderFns } from "./ListServices.vue?vue&type=template&id=2d4c9960"
import script from "./ListServices.vue?vue&type=script&lang=js"
export * from "./ListServices.vue?vue&type=script&lang=js"
import style0 from "./ListServices.vue?vue&type=style&index=0&id=2d4c9960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports